import React from 'react';
import { Mail, Phone, MapPin, Send, Clock } from 'lucide-react';
export function Contact() {
  return <div className="bg-[#f8f9fa] min-h-screen py-12" data-id="element-401">
      <div className="max-w-7xl mx-auto px-4" data-id="element-402">
        <div className="text-center mb-12" data-id="element-403">
          <h1 className="text-3xl font-bold text-gray-900 mb-3" data-id="element-404">Contáctanos</h1>
          <p className="text-gray-600 max-w-xl mx-auto" data-id="element-405">
            Estamos aquí para ayudarte. Contáctanos para cotizaciones, asesoría
            técnica o cualquier consulta sobre nuestros productos.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-406">
          {/* Contact Info */}
          <div className="lg:col-span-1 space-y-4" data-id="element-407">
            <div className="bg-white p-6 rounded-lg border border-gray-100" data-id="element-408">
              <div className="flex items-start gap-4 mb-6 pb-6 border-b border-gray-100" data-id="element-409">
                <div className="p-3 bg-blue-50 rounded-lg text-[#0056b3]" data-id="element-410">
                  <Phone className="w-5 h-5" data-id="element-411" />
                </div>
                <div data-id="element-412">
                  <h3 className="font-semibold text-gray-900 mb-1" data-id="element-413">Llámanos</h3>
                  <p className="text-gray-600" data-id="element-414">+58 412-4279146</p>
                  <p className="text-gray-400 text-sm mt-1" data-id="element-415">
                    Lun - Sáb, 8am - 6pm
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4 mb-6 pb-6 border-b border-gray-100" data-id="element-416">
                <div className="p-3 bg-blue-50 rounded-lg text-[#0056b3]" data-id="element-417">
                  <Mail className="w-5 h-5" data-id="element-418" />
                </div>
                <div data-id="element-419">
                  <h3 className="font-semibold text-gray-900 mb-1" data-id="element-420">
                    Escríbenos
                  </h3>
                  <p className="text-gray-600" data-id="element-421">ventas@materialesbrasil.com</p>
                  <p className="text-gray-400 text-sm mt-1" data-id="element-422">
                    Respuesta en 24 horas
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4 mb-6 pb-6 border-b border-gray-100" data-id="element-423">
                <div className="p-3 bg-blue-50 rounded-lg text-[#0056b3]" data-id="element-424">
                  <MapPin className="w-5 h-5" data-id="element-425" />
                </div>
                <div data-id="element-426">
                  <h3 className="font-semibold text-gray-900 mb-1" data-id="element-427">
                    Visítanos
                  </h3>
                  <p className="text-gray-600" data-id="element-428">Caracas, Venezuela</p>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-429">
                <div className="p-3 bg-blue-50 rounded-lg text-[#0056b3]" data-id="element-430">
                  <Clock className="w-5 h-5" data-id="element-431" />
                </div>
                <div data-id="element-432">
                  <h3 className="font-semibold text-gray-900 mb-1" data-id="element-433">Horario</h3>
                  <p className="text-gray-600" data-id="element-434">Lunes a Sábado</p>
                  <p className="text-gray-400 text-sm" data-id="element-435">8:00 AM - 6:00 PM</p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="lg:col-span-2" data-id="element-436">
            <form className="bg-white p-6 md:p-8 rounded-lg border border-gray-100" data-id="element-437">
              <h2 className="text-xl font-semibold text-gray-900 mb-6" data-id="element-438">
                Envíanos un mensaje
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-439">
                <div data-id="element-440">
                  <label className="text-sm font-medium text-gray-700 mb-1 block" data-id="element-441">
                    Nombre
                  </label>
                  <input type="text" className="w-full px-4 py-2.5 border border-gray-200 rounded-md focus:ring-2 focus:ring-[#0056b3] focus:border-transparent outline-none text-sm" placeholder="Tu nombre" data-id="element-442" />
                </div>
                <div data-id="element-443">
                  <label className="text-sm font-medium text-gray-700 mb-1 block" data-id="element-444">
                    Email
                  </label>
                  <input type="email" className="w-full px-4 py-2.5 border border-gray-200 rounded-md focus:ring-2 focus:ring-[#0056b3] focus:border-transparent outline-none text-sm" placeholder="tucorreo@ejemplo.com" data-id="element-445" />
                </div>
              </div>
              <div className="mb-4" data-id="element-446">
                <label className="text-sm font-medium text-gray-700 mb-1 block" data-id="element-447">
                  Teléfono
                </label>
                <input type="tel" className="w-full px-4 py-2.5 border border-gray-200 rounded-md focus:ring-2 focus:ring-[#0056b3] focus:border-transparent outline-none text-sm" placeholder="+58 412-0000000" data-id="element-448" />
              </div>
              <div className="mb-4" data-id="element-449">
                <label className="text-sm font-medium text-gray-700 mb-1 block" data-id="element-450">
                  Asunto
                </label>
                <input type="text" className="w-full px-4 py-2.5 border border-gray-200 rounded-md focus:ring-2 focus:ring-[#0056b3] focus:border-transparent outline-none text-sm" placeholder="¿En qué podemos ayudarte?" data-id="element-451" />
              </div>
              <div className="mb-6" data-id="element-452">
                <label className="text-sm font-medium text-gray-700 mb-1 block" data-id="element-453">
                  Mensaje
                </label>
                <textarea rows={5} className="w-full px-4 py-2.5 border border-gray-200 rounded-md focus:ring-2 focus:ring-[#0056b3] focus:border-transparent outline-none resize-none text-sm" placeholder="Escribe tu mensaje aquí..." data-id="element-454"></textarea>
              </div>
              <button className="w-full md:w-auto px-6 py-2.5 bg-[#0056b3] text-white font-medium rounded-md hover:bg-[#004494] transition-colors flex items-center justify-center gap-2" data-id="element-455">
                Enviar Mensaje
                <Send className="w-4 h-4" data-id="element-456" />
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>;
}